import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/analytics";
import { Config, firebaseConfig, firebaseConfig_test } from '../Config';
import { isBrowser, isAndroid} from 'react-device-detect';

export default class FirebaseLogger {

    static myInstance = null;
    _initiated = null;
    _initError = null;

    /**
     * @returns {FirebaseLogger}
     */
    static getInstance() {
		if (FirebaseLogger.myInstance == null) {
			FirebaseLogger.myInstance = new FirebaseLogger();
			this.myInstance._init();
		}
		return this.myInstance;
    }

    async _init() {
		if (this._initiated) return false;
		try {
			const configToUse = Config.test == "0" ? firebaseConfig : firebaseConfig_test;
			this._initiated = true;
			firebase.initializeApp(configToUse);

			// Initialize Analytics explicitly
			if (firebase.analytics) {
				firebase.analytics();
			}

			return true;
		} catch (error) {
			this._initError = error;
			console.error("[FirebaseLogger] Failed to initialize:", error.message);
			return false
		}
    }

    getStatus() {
		const configToUse = Config.test == "0" ? firebaseConfig : firebaseConfig_test;
		return {
			initiated: this._initiated,
			hasError: this._initError !== null,
			errorMessage: this._initError ? this._initError.message : null,
			firebaseAppsCount: firebase.apps ? firebase.apps.length : 0,
			mode: Config.test == "0" ? "PRODUCTION" : "TEST",
			projectId: configToUse.projectId,
			analyticsAvailable: firebase.analytics ? true : false
		};
    }

    regEvent(eventName, params, action) {
		try {
			let eventPrefix = Config.test == 1 ? "TEST_WEB_" : "WEB_";
			if (action) eventPrefix += action + "_";
			params.os = isBrowser ? "web" : isAndroid ? "android" : "ios";

			firebase.analytics().logEvent(eventPrefix + eventName, params);
			return true;
		} catch (error) {
			console.error('[FirebaseLogger] Failed to log event:', error);
			return false;
		}
    }
}



// WEBPACK FOOTER //
// ./src/libs/FirebaseLogger.js